import { axiosInstance } from "../../config/axios";
import { APIURL } from "../../configApi";

const StockService = {};
StockService.getCategories = (data) => {
  return axiosInstance.get(`${APIURL}/global/stock/categories${data}`);
};

StockService.getSuppliers = (data) => {
  return axiosInstance.get(`${APIURL}/global/stock/suppliers${data}`);
};

StockService.getProducts = (data) => {
  return axiosInstance.get(`${APIURL}/global/stock/products${data}`);
};

StockService.addCategory = (data) => {
  return axiosInstance.post(`${APIURL}/global/stock/categories`, data);
};

StockService.addProduct = (data) => {
  return axiosInstance.post(`${APIURL}/global/stock/products`, data);
};

StockService.addPurchase = (data) => {
  return axiosInstance.post(`${APIURL}/global/stock/supplier-invoices`, data);
};

StockService.getCategoryById = (id) => {
  return axiosInstance.get(`${APIURL}/global/stock/categories/${id}`);
};

StockService.retirerProduct = (data) => {
  return axiosInstance.post(`${APIURL}/global/stock/historical-used`, data);
};

export default StockService;
